import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-step-resource-creation',
  templateUrl: './step-resource-creation.component.html',
  styleUrls: ['./step-resource-creation.component.css']
})
export class StepResourceCreationComponent {
  @Input() form!: FormGroup;
  @Input() description = 'Resources are created when a participant accesses the class for the first time.';
}
